import { formatIsoDate } from "../Format";

export type LicenceStatus = 'inactive' | 'revoked' | 'new' | 'modified' | 'synced';

export class Licence {

   static parse(source: any = {}): Licence {
      return new Licence(
         parseRequiredIntProperty('id', source),
         parseRequiredIntProperty('instanceId', source),
         source['startDate'],
         source['endDate'],

         !!source['reportRequired'],
         Number.parseInt(source['maxActiveUsers']) ?? null,
         Number.parseInt(source['maxActivePatients']) ?? null,
         source['moduleIds'] ?? [],
         source['programTypeIds'] ?? [],

         dateTimeFromString(source['lastSync']),
         source['editedBy'],
         source['revokedBy'] ?? null,
         dateTimeFromString(source['lastModified']) ?? new Date()
      );
   }

   constructor(
      readonly id: number,
      readonly instanceId: number,
      readonly startDate: string,
      readonly endDate: string,

      readonly reportRequired: boolean,
      readonly maxActiveUsers: number | null,
      readonly maxActivePatients: number | null,
      readonly moduleIds: number[],
      readonly programTypeIds: number[],

      readonly lastSync: Date | null,
      readonly editedBy: string,
      readonly revokedBy: string | null,
      readonly lastMod: Date
   ) {
      const today: string = formatIsoDate(new Date());
      const activeForDateRange = this.startDate <= today && this.endDate >= today;
      const revokedAndClientAware = this.revokedBy && this.lastSync != null && this.lastSync.getTime() > this.lastMod.getTime();

      this.active = activeForDateRange && !revokedAndClientAware;
      this.readOnly = !this.active || !!this.revokedBy;
      this.status = !this.active && 'inactive'
         || this.revokedBy && 'revoked'
         || !this.lastSync && 'new'
         || this.lastMod.getTime() > this.lastSync!.getTime() && 'modified'
         || 'synced';
   }

   readonly active: boolean;
   readonly readOnly: boolean;
   readonly status: LicenceStatus
}

function parseRequiredIntProperty(propName: string, source: any): number {
   const value: number = Number.parseInt(source[propName]);
   if (isNaN(value)) {
      throw new Error(`Missing expected property '${propName}', or is invalid integer.`);
   }
   return value;
}

function dateTimeFromString(string?: string): Date | null {
   if (!string) {
      return null;
   }
   if (!string.endsWith("Z")) {
      string += "Z";
   }
   return new Date(string);
}
